import { useSelector, useDispatch } from "react-redux"
import { useTranslation } from "react-i18next"

import ModalService from "src/modals"
import { claimDaily, selectCredits, selectDailyClaimable } from "src/store/economy"
import { addMessage } from "src/store/messages"
import { selectIsAuthenticated } from "src/store/user"

import "./CreditsBadge.css"

const formatCredits = (credits) => String(credits ?? 0).replace(/\B(?=(\d{3})+(?!\d))/g, " ")

/* The balance, in the header, next to the player's name.

   It is the one number a paid game has to keep visible: a player who cannot see what they have
   discovers the entry fee by being refused. Clicking opens the shop.

   The dot is the daily grant waiting to be claimed. A reward the player has to go looking for is a
   reward that goes unclaimed, so the badge says there is one and takes one click to take it —
   without opening the shop, which is a different intention. */
const CreditsBadge = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const isAuthenticated = useSelector(selectIsAuthenticated)
  const credits = useSelector(selectCredits)
  const claimable = useSelector(selectDailyClaimable)

  // Signed out there is no wallet, and `credits === null` is "not read yet" rather than zero —
  // rendering "0" at somebody with plenty is worse than rendering nothing for a moment.
  if (!isAuthenticated || credits === null) return null

  const claim = (event) => {
    event.stopPropagation()
    dispatch(claimDaily())
      .unwrap()
      .then((result) =>
        dispatch(addMessage({ text: t("shop.dailyClaimed", { credits: result.granted }), type: "success" }))
      )
      .catch(() => dispatch(addMessage({ text: t("shop.dailyFailed"), type: "error" })))
  }

  return (
    <div className="credits-badge">
      <button
        type="button"
        className="credits-badge-amount"
        onClick={() => ModalService.show("ShopModal")}
        title={t("shop.openShop")}
      >
        <span className="credits-badge-mark">◈</span>
        {formatCredits(credits)}
      </button>
      {claimable ? (
        <button type="button" className="credits-badge-daily" onClick={claim} title={t("shop.dailyWaiting")}>
          +
        </button>
      ) : null}
    </div>
  )
}

export default CreditsBadge
